"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpstreamCollectiveToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AmountLowerThanMinEthContribution",
        type: "error",
    },
    {
        inputs: [],
        name: "AmountTooHigh",
        type: "error",
    },
    {
        inputs: [],
        name: "AmountTooLow",
        type: "error",
    },
    {
        inputs: [],
        name: "DepositsDisabled",
        type: "error",
    },
    {
        inputs: [],
        name: "EmptyInitialMembers",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToCallRemote",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToCallRemoteWithValue",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToSendEther",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToSendFee",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransferERC1155",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransferERC721",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransferTokens",
        type: "error",
    },
    {
        inputs: [],
        name: "NotAMember",
        type: "error",
    },
    {
        inputs: [],
        name: "NotUpstream",
        type: "error",
    },
    {
        inputs: [],
        name: "WithdrawsDisabled",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddress",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "disableTokenTransfers",
                type: "bool",
            },
        ],
        name: "DisableTokenTransfersChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bool",
                name: "enableDeposits",
                type: "bool",
            },
        ],
        name: "EnableDepositsChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bool",
                name: "enableWithdraws",
                type: "bool",
            },
        ],
        name: "EnableWithdrawsChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "previousRate",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "newRate",
                type: "uint256",
            },
        ],
        name: "ExchangeRateChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "feeAmount",
                type: "uint256",
            },
        ],
        name: "FeePaid",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "depositFee",
                type: "uint256",
            },
        ],
        name: "FeesChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bool",
                name: "gateDeposits",
                type: "bool",
            },
        ],
        name: "GateDepositsChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "targetMember",
                type: "address",
            },
        ],
        name: "MemberAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "member",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "etherAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
        ],
        name: "MemberDepositedFunds",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "targetMember",
                type: "address",
            },
        ],
        name: "MemberRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "member",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "etherAmount",
                type: "uint256",
            },
        ],
        name: "MemberWithdrewFunds",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "contributionAmount",
                type: "uint256",
            },
        ],
        name: "MinEthContributionChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "etherAmount",
                type: "uint256",
            },
        ],
        name: "NonDepositEtherReceived",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
        ],
        name: "TokensSent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "targetMember",
                type: "address",
            },
        ],
        name: "addMember",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burnFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "callRemote",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "callRemoteWithValue",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_disableTokenTransfers",
                type: "bool",
            },
        ],
        name: "changeDisableTokenTransfers",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newRate",
                type: "uint256",
            },
        ],
        name: "changeExchangeRate",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_contributionAmount",
                type: "uint256",
            },
        ],
        name: "changeMinEthContribution",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "deposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "depositFee",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "disableTokenTransfers",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "enableDeposits",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "enableWithdraws",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "exchangeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "gateDeposits",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_tokenName",
                type: "string",
            },
            {
                internalType: "string",
                name: "_tokenSymbol",
                type: "string",
            },
            {
                internalType: "address",
                name: "_multisigAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_upstreamWalletAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_depositFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_premintAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_minEthContribution",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "_disableTokenTransfers",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "_gateDeposits",
                type: "bool",
            },
            {
                internalType: "address[]",
                name: "_initialMembers",
                type: "address[]",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_msgHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_signature",
                type: "bytes",
            },
        ],
        name: "isValidSignature",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "members",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minEthContribution",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155BatchReceived",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC1155Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "onERC721Received",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "targetMember",
                type: "address",
            },
        ],
        name: "removeMember",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "sendEther",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
        ],
        name: "sendTokens",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_depositFee",
                type: "uint256",
            },
        ],
        name: "setDepositFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_upstreamWalletAddress",
                type: "address",
            },
        ],
        name: "setUpstreamWalletAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "newValue",
                type: "bool",
            },
        ],
        name: "toggleEnableDeposits",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "newValue",
                type: "bool",
            },
        ],
        name: "toggleEnableWithdraws",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "newValue",
                type: "bool",
            },
        ],
        name: "toggleGateDeposits",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "callAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferERC1155",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "callAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferERC721",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "callAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokens",
                type: "uint256",
            },
        ],
        name: "transferTokens",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "upstreamWalletAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenAmount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [
            {
                internalType: "bool",
                name: "success",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class UpstreamCollectiveToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.UpstreamCollectiveToken__factory = UpstreamCollectiveToken__factory;
UpstreamCollectiveToken__factory.bytecode = _bytecode;
UpstreamCollectiveToken__factory.abi = _abi;
